module.exports = __webpack_public_path__ + "img/473w.4d7f416.jpg";